import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    subscribeError: "No se pudo completar la suscripción",
    genericError: "Error al suscribirse",
    done: "¡Listo! Te avisamos cada viernes y lunes con los planes.",
    title: "Nunca más te pierdas un plan",
    body: "Recibe los mejores planes cada viernes y la agenda completa cada lunes.",
    emailPlaceholder: "tu@correo.cl",
    subscribe: "Suscribirme",
    close: "Cerrar",
  },
  en: {
    subscribeError: "Couldn't complete the subscription",
    genericError: "Subscription error",
    done: "Done! We'll write to you every Friday and Monday with plans.",
    title: "Never miss a plan again",
    body: "Get the best plans every Friday and the full agenda every Monday (in Spanish).",
    emailPlaceholder: "you@email.com",
    subscribe: "Subscribe",
    close: "Close",
  },
});
